import Button from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";

export const Container = styled("div")<{ scale: number }>`
	width: 22em;
	height: 23em;
	padding: 0px;
	position: relative;
	display: flex;
	justify-content: center;
	overflow: hidden;
	border-radius: 22px;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
	background-color: #fffaf1;
	font-size: 18px;
`;

export const Background = styled.div<{ imageUrl?: string }>`
	content: url(${(props) => props.imageUrl});
	width: 100%;
	height: 100%;
`;

export const OfferItem = styled.div`
	position: relative;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	padding: 0.5em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: auto;
	z-index: 999;
	align-content: stretch;
	width: 100%;
`;

export const LoyaltyContainer = styled.div`
	position: relative;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	gap: 0.5rem;

	box-sizing: border-box;
	width: 100%;
	height: auto;
	min-height: 3.6em;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 93%;
	bottom: 5%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const Items = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	flex-wrap: nowrap;
`;

export const RewardItem = styled.div<{ width: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
`;

export const RewardAmountContainer = styled.div``;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 3em;

	&.crown {
		width: 2.5em;
		height: 2.5em;
	}
`;

export const Title = styled.div`
	position: absolute;
	max-width: 80%;
	top: 11%;
	color: #113b62;
	text-align: center;
	justify-content: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: Baloo;
	font-size: 1.9em;
	font-style: normal;
	line-height: 0.9em;
	height: 2.2em;
`;

export const Text = styled.div`
	-webkit-text-stroke-width: 0.22em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	font-weight: 400;
	font-family: Baloo;
`;

export const RewardAmount = styled(Text)`
	font-size: 0.9em;
`;

export const SubTitle = styled(Text)`
	width: 100%;
	margin-left: 1.5em;
	font-size: 0.9em;
	line-height: 2.1em;
`;

export const InfoContainer = styled(Text)`
	font-size: 0.9em;
	display: flex;
	align-items: left;
	flex-direction: column;
	justify-content: center;
`;

export const LoyaltyPoints = styled(Text)`
	font-size: 1em;
`;

export const CrossOutValue = styled(Text)`
	font-size: 0.9em;
	color: #eb5757;
	font-weight: 700;
	text-decoration: line-through;
`;

export const PoisBounty = styled(Text)`
	font-size: 0.9em;
	color: #fbbd05;
	font-weight: 700;
`;

export const CustomButtom = styled(Button)`
	width: 19em;
	margin-top: 1em;
	height: 2.9em;
	font-size: 1em;
`;

export const InfoButton = styled.img`
	position: absolute;
	top: 10%;
	right: 2%;
	z-index: 2;
	width: 1.5em;
	height: 1.5em;
	cursor: pointer;
`;

export const bannerStyle: CSSProperties = {
	height: "2.2em",
	display: "flex",
	alignItems: "center"
};

export const textStyle: CSSProperties = {
	lineHeight: "2.2em",
	fontSize: "0.9em"
};
